import { AJAX_PUBLIC_REQUEST } from '../../Constants/AppConstants';

export function newPasswordResetRequest(userData) {
    return dispatch => {
        return AJAX_PUBLIC_REQUEST("POST","operator/resetPassword",userData);
    }
}